//#region libraries
import React from "react";

// custom components
import { Screen } from "_atoms";
import { BookingsList, BookingsListForecast } from "_organisms";

// bootstrap
import Row from "react-bootstrap/Row";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectUserDb } from "_redux/slices/main-screen/user";
import { selectAirlineSelectedAirport, selectSelectedView, setSelectedView } from "_redux/slices/prm-bookings/bookings";
//scenes
import WeeklyAnalytics from "_scenes/portal/analytics/booking-analytics/weeklyAnalytics";
import DailyAnalytics from "_scenes/portal/analytics/booking-analytics/dailyAnalytics";
import ByFlightAnalytics from "_scenes/portal/analytics/booking-analytics/byFlightAnalytics";
import BookingsByFlight from '_scenes/portal/analytics/booking-analytics/bookingsByFlight';
import SecurityAnalytics from "_scenes/portal/analytics/booking-analytics/securityAnalytics";

// tremor librarues
import { ColGrid, Tab, TabList, Metric } from "@tremor/react";
//#endregion

const BookingAnalytics = (props) => {
  
  //#region redux
  const dispatch = useDispatch();
  const userDb = useSelector(selectUserDb);
  const selectedView = useSelector(selectSelectedView);
  const airport = useSelector(selectAirlineSelectedAirport);
  //#endregion

  const isSecurity = userDb.role === "SECURITY";
  const isAirline = userDb.details.type === "AIRLINE";

  const tabs = [
    { value: 1, text: "Bookings" },
    ...(isSecurity ? [{ value: 6, text: "Security" }] : []),
    ...(!isSecurity && !isAirline ? [
      { value: 2, text: "Booking Forecast" },
      { value: 3, text: "Flight Forecast" },
    ] : []),
    ...(!isSecurity ? [
      { value: 4, text: "7 Day Analytics" },
      { value: 5, text: "Bookings By Flight" },
    ] : []),
  ];

  return (
    <Screen>
      <Row>

        {/* Tab Picker */}
        <TabList
          defaultValue={selectedView}
          onValueChange={(value) => dispatch(setSelectedView(value))}
          marginTop="mt-6"
        >
          {tabs.map((t) => (
            <Tab key={t.value} value={t.value} text={t.text} />
          ))}
        </TabList>

        {/* Show Selected Airport if Airline Account */}
        {userDb.details.type == "AIRLINE" && (
          <Metric>{airport ? airport : ""}</Metric>
        )}

        {/* Tab Content */}
        <ColGrid marginTop="mt-2">
          {selectedView == 1 && (
            <>
              <DailyAnalytics></DailyAnalytics>
              {!isSecurity && <BookingsList />}
            </>
          )}
          {selectedView == 2 && <BookingsListForecast />}
          {selectedView == 3 && (
            <>
              <ByFlightAnalytics></ByFlightAnalytics>
            </>
          )}

          {selectedView == 4 && (
            <>
              <WeeklyAnalytics></WeeklyAnalytics>
            </>
          )}

          {selectedView == 5 && <BookingsByFlight />}
          {selectedView == 6 && <SecurityAnalytics />}
        </ColGrid>
      </Row>
    </Screen>
  );
};

export default BookingAnalytics;
